import fetch, { parseListResponse, parseResponse } from "./fetch";

export interface FamilleInterface {
    id: number;
    name: string;
    secteur_name: string;
}

class Famille {
    all(params?: HashMap<any>) {
        return parseListResponse<FamilleInterface>(fetch.get(`familles/`, { params }));
    }

    one(id: string) {
        return parseResponse<FamilleInterface>(fetch.get(`familles/${id}`));
    }

    autocomplete(params?: HashMap<any>) {
        return fetch.get(`familles/autocomplete/`, { params });
    }
}

export default new Famille();
